import { render, staticRenderFns } from "./Ownership.vue?vue&type=template&id=4f5d1460&scoped=true&"
import script from "./Ownership.vue?vue&type=script&lang=js&"
export * from "./Ownership.vue?vue&type=script&lang=js&"
import style0 from "./Ownership.vue?vue&type=style&index=0&id=4f5d1460&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4f5d1460",
  null
  
)

export default component.exports